import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { get } from "lodash";

import "./cricket-widget.m.css";

const CricketWidget = () => {
  const [isMobile, setIsMobile] = useState(false);
  const [timer, setTimer] = useState(false);

  const qtState = useSelector((state) => get(state, ["qt"], {}));
  const cricketWidgetConfig = qtState?.data?.frontendConfig?.cricketWidgetConfig;
  const [widgetData, setWidgetData] = useState(null);

  useEffect(() => {
    const fetchWidgetData = async () => {
      try {
        const response = await fetch(
          "https://www.deccanherald.com/custom-widget-json"
        );
        const data = await response.json();
        setWidgetData(data);
      } catch (error) {
        console.error("Error fetching widget data:", error);
      }
    };
    if(timer){
      fetchWidgetData();
    }
  }, [timer]);

  if (!cricketWidgetConfig?.enabled) {
    return null;
  }

  const [isClosed, setIsClosed] = useState(false);

  useEffect(() => {
    try {
      if (sessionStorage.getItem("cricket_widget_closed") === "1") {
        setIsClosed(true);
      }
    } catch (e) {}
  }, []);

  useEffect(() => {

    if (window?.innerWidth < 767) {
      setIsMobile(true);
    }

    // Delay showing widget by 3 seconds
    const timeout = setTimeout(() => {
      setTimer(true);
    }, 3000);

    return () => clearTimeout(timeout);
  }, []);

  return (
    <>{timer && widgetData?.enabled && !isClosed && (
      <iframe
              src={`/cricket-widget/index.html`}
              title="Cricket Widget"
              style={{
                maxHeight: "128px",
                width: isMobile ? "175px" : "187px",
                position: "fixed",
                border: "none",
                bottom: isMobile ? "180px" : "125px",
                right: isMobile ? "12px" : "24px",
                zIndex: "9999",
              }}
    />)}</>
  );
};

export default CricketWidget;


